module.exports = __webpack_public_path__ + "img/cns_email_ios1.54931e95.png";